import { colors } from "../../data/colors";
import { stdObject } from "../../data/types/stdObject";
import CategoriesList from "../../screens/MainStructure/components/CategoriesList";
import FilesManager from "../FilesModal/FilesManager";
import TextEditor from "../TextEditor";
import Commissions from "./Item/Commissions";
import DocRecordsBox from "./Item/DocRecordsBox";
import ImagesBox from "./Item/ImagesBox";
import Prices from "./Item/Prices";
import WriteInput from "./WriteInput";
import { writeTable } from "./writeTable";

export default function WriteInputList({
  inputs,
  tabs,
  tabIndex,
  tableTab,
  table = [],
  tableStyle = {},
  isList,
  style = {},
  mainColor,
}: {
  inputs: stdObject;
  tabs: stdObject;
  tabIndex: number;
  tableTab?: number;
  table?: any[];
  tableStyle?: stdObject;
  isList?: boolean;
  style: stdObject;
  mainColor: string;
}) {
  return inputs.length > 0 ? (
    <div
      style={{
        position: "relative",
        flex: 1,
        display: "flex",
        justifyContent: "center",
      }}
    >
      {tabs.length === 0 ? (
        <div className="modalInputsBox" style={{ ...style }}>
          <table width="100%" cellSpacing={0} cellPadding={3}>
            <tbody>
              {inputs
                .filter(
                  (e: stdObject) =>
                    tabs.length === 0 ||
                    (tabs.length > 0 && e.tabId === tabs[0].code),
                )
                .map(
                  (e: stdObject, index: number) =>
                    e && <WriteInput key={index} data={e} isTable={true} />,
                )}
            </tbody>
          </table>
        </div>
      ) : (
        tabs.map(
          (e: stdObject, index: number) =>
            e && (
              <div
                key={index}
                className="secondInputBox"
                style={{
                  position: index === 0 ? "relative" : "absolute",
                  height: tabIndex === e.code || index === 0 ? "100%" : "0px",
                  zIndex: tabIndex === e.code ? 2 : 0,
                  opacity: tabIndex === e.code ? 1 : 0,
                  backgroundColor: colors.white,
                }}
              >
                <table width="100%" cellSpacing={0} cellPadding={3}>
                  <tbody>
                    {inputs
                      .filter(
                        (v: stdObject) =>
                          typeof v === "object" &&
                          "tabId" in v &&
                          (v.tabId === e.code || v.tabId === -1),
                      )
                      .map(
                        (o: stdObject, idx: number) =>
                          o &&
                          (["info"].includes(o.type) ||
                          [
                            "FAM",
                            "IMG",
                            "PRE",
                            "COMM",
                            "DES",
                            "REC",
                            "FIL",
                          ].includes(o.code) ? (
                            <tr key={idx}>
                              <td>
                                {o.type === "info" ? (
                                  <div style={{ padding: 3, ...o.style }}>
                                    <span className="inputLabel">
                                      {`${o.label}: `}
                                    </span>
                                    {o.value}
                                  </div>
                                ) : o.code === "FAM" ? (
                                  <CategoriesList data={o} />
                                ) : o.code === "IMG" ? (
                                  <ImagesBox data={o} />
                                ) : o.code === "PRE" ? (
                                  <Prices data={o} />
                                ) : o.code === "COMM" ? (
                                  <Commissions data={o} />
                                ) : o.code === "DES" ? (
                                  <TextEditor data={o} />
                                ) : o.code === "REC" ? (
                                  <DocRecordsBox data={o} />
                                ) : o.code === "FIL" ? (
                                  <FilesManager
                                    init={o.files.type}
                                    filesButtons={{
                                      [o.files.type]: {
                                        code: o.files.code,
                                        label: "p.files",
                                        list: o.files.list ?? [],
                                      },
                                    }}
                                    updateRoot={() => {}} // updateFilesDoc
                                    mainColor={mainColor}
                                    level={4}
                                  />
                                ) : (
                                  <></>
                                )}
                              </td>
                            </tr>
                          ) : (
                            <WriteInput key={idx} data={o} isTable={true} />
                          )),
                      )}
                  </tbody>
                </table>
                {!!tableTab &&
                  tableTab === e.code &&
                  writeTable(table, tableStyle, isList)}
              </div>
            ),
        )
      )}
    </div>
  ) : (
    <></>
  );
}
